import { UserMin, UserMinListParams } from '@apiContract';

export type UserMap = { [id: string]: UserMin };

export type MultiSelectReturn = {
  selectedUsers: UserMap;
  deletedUsers: UserMap;
};

export type SingleSelectReturn = UserMin | null;

export type UserDrawerReturnType = MultiSelectReturn | SingleSelectReturn;

export type UserDrawerSaveFunc = (users: UserDrawerReturnType) => void;

interface SelectUsersPropsBase {
  isOpened: boolean;
  isNewInstance?: boolean;
  onClose: () => void;
  onSave: UserDrawerSaveFunc;
  model: string;
  additionalAllParams?: UserMinListParams;
  noSelected?: boolean;
  title?: string;
}

export interface SelectUsersPropsSingleSelect extends SelectUsersPropsBase {
  isSingleSelect: true;
  selected?: UserMin;
  additionalSelectedParams?: never;
  deleted?: never;
  filterOwner?: boolean;
}

export interface SelectUsersPropsMultiSelect extends SelectUsersPropsBase {
  isSingleSelect?: false;
  selected?: UserMap;
  additionalSelectedParams?: UserMinListParams;
  deleted?: UserMap;
  noItemsSetMessage?: string;
  checkForExistingLocation?: boolean;
}

export type SelectUsersProps = SelectUsersPropsSingleSelect | SelectUsersPropsMultiSelect;

export type DrawerContentPropsMultiSelect = {
  model: string;
  onClose: () => void;
  onSave: UserDrawerSaveFunc;
  additionalAllParams?: UserMinListParams;
  additionalSelectedParams?: UserMinListParams;
  selected?: UserMap;
  deleted?: UserMap;
  noSelected?: boolean;
  noItemsSetMessage?: string;
  title?: string;
  checkForExistingLocation?: boolean;
};

export type DrawerContentPropsSingleSelect = {
  model: string;
  onClose: () => void;
  onSave: UserDrawerSaveFunc;
  additionalAllParams?: UserMinListParams;
  selected?: UserMin;
  title?: string;
  filterOwner?: boolean;
};

export enum TabValues {
  ALL_USERS = 'all',
  SELECTED_USERS = 'selected',
}
